import { render, staticRenderFns } from "./dashboardAwblist.vue?vue&type=template&id=bf26f420"
import script from "./dashboardAwblist.vue?vue&type=script&lang=js"
export * from "./dashboardAwblist.vue?vue&type=script&lang=js"
import style0 from "./dashboardAwblist.vue?vue&type=style&index=0&id=bf26f420&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports